var wrap = function (min, max, v) {
    var rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

export { wrap };



//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion/dist/es/utils/wrap.js
// module id = null
// module chunks = 